import { ChangeEvent, useEffect, useState } from "react"
import { AiFillPlusCircle } from "react-icons/ai";
import { LuTrash2 } from "react-icons/lu";

import { jsonKeyToString } from "../../../helpers/jsonToString"
import { useDispatch } from 'react-redux'
import { useSetCustomDefects } from "../../../api/useSettings"
import { SpinnerCustom } from "../../ui/SpinnerCustom"
import toast from "react-hot-toast"
import { startChecking } from "../../../store/asyncMethods/authMethods"

import { SelectDefect } from "../../ui/SelectDefect";
import { ModalAddDefect } from "../../ui/ModalAddDefect";

interface Props {
    pallgrowMinor: string[]
    pallgrowMajor: string[]
    personalPallgrowMinor: string[]
    personalPallgrowMajor: string[]
}

interface CheckData {
    check: boolean
    key: string,
}
export const CustomFieldsDefect = ({ pallgrowMinor, pallgrowMajor, personalPallgrowMinor, personalPallgrowMajor }: Props) => {

    const [minor, setMinor] = useState<CheckData[]>([])
    const [major, setMajor] = useState<CheckData[]>([])

    // const [dataCustom, setDataCustom] = useState<CheckData[]>([])
    const [openModal, setOpenModal] = useState<boolean>(false)

    const { mutate, isLoading } = useSetCustomDefects()
    const dispatch = useDispatch()

    useEffect(() => {
        const allMinor: CheckData[] = []
        personalPallgrowMinor.forEach((key) => {
            allMinor.push(
                {
                    check: pallgrowMinor.includes(key) ? true : false,
                    key,
                }
            )
        })
        setMinor(allMinor)
        const allMajor: CheckData[] = []
        personalPallgrowMajor.forEach((key) => {
            allMajor.push(
                {
                    check: pallgrowMajor.includes(key) ? true : false,
                    key,
                }
            )
        })
        setMajor(allMajor)
    }, [pallgrowMinor, pallgrowMajor, personalPallgrowMinor, personalPallgrowMajor])


    const handleCheck = (e: ChangeEvent<HTMLInputElement>, isMajor: boolean = false) => {

        const checkItem = (isMajor ? major : minor).map(item => {
            if (item.key === e.target.name) {
                return {
                    ...item,
                    check: !item.check
                }
            }
            return item
        })

        isMajor ? setMajor(checkItem) : setMinor(checkItem)
    }

    const handleSend = () => {
        
        const finalData = (data:CheckData[]):string[] => {
            return data.filter(item => item.check).map(item => item.key)
        }
        
        if ((finalData(minor).length + finalData(major).length) === 0) {
            return toast.error("You must select at least one field")
        }

        mutate({ 
            minor: finalData(minor),
            major: finalData(major),
            allMinor: minor.map(item => item.key),
            allMajor: major.map(item => item.key),
         }, {
            onSuccess: () => {
                dispatch(startChecking())
                toast.success('Settings updated')
            }
        })
    }

    const handleNewDefect = (label: string, name: string, isMajor: boolean) => {

        if ((isMajor ? major : minor).find(item => item.key === name)) return toast.error("This input already exist")

        const newItem = {
            check: true,
            key: name
        }
        isMajor ? setMajor(prev => [...prev, newItem]) : setMinor(prev => [...prev, newItem])
        setOpenModal(false)
    };

    const deleteCustomItem = (itemName: string, isMajor: boolean = false) => {
        const filtred = (isMajor ? major : minor).filter(item => item.key !== itemName)
        isMajor ? setMajor(filtred) : setMinor(filtred)
    };

    const handleSelectDefect = (_: string, name: string, isMajor: boolean | null) => {
        if (isMajor === null) return

        if ((isMajor ? major : minor).find(item => item.key === name)) return

        const newItem = {
            check: true,
            key: name
        }
        isMajor ? setMajor(prev => [...prev, newItem]) : setMinor(prev => [...prev, newItem])
    }

    return (
        <>
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                <div className="tw-border tw-border-orange-300 tw-bg-orange-50 tw-rounded-xl tw-p-4">
                    <SelectDefect isDefect={{ type: "minor", selectedDefects: minor.map(item => item.key) }} handleSelectDefect={handleSelectDefect} />
                    {minor.length > 0 &&
                        <div className="tw-mt-4 tw-space-y-2">
                            {
                                minor.map(item => (
                                    <div key={`minor-${item.key}`} className="tw-flex tw-items-center">
                                        {
                                            <input
                                                type="checkbox"
                                                name={item.key}
                                                checked={item.check}
                                                onChange={(e) => handleCheck(e)}
                                            />
                                        }
                                        <label className="tw-flex tw-items-center tw-ml-2">{jsonKeyToString(item.key)}
                                            <button className="tw-ml-2" onClick={() => deleteCustomItem(item.key)}><LuTrash2 size={15} /></button>
                                        </label>
                                    </div>

                                ))
                            }
                        </div>
                    }
                </div>
                <div className="tw-border tw-border-red-300 tw-bg-red-50 tw-rounded-xl tw-p-4">
                    <SelectDefect isDefect={{ type: "major", selectedDefects: major.map(item => item.key) }} handleSelectDefect={handleSelectDefect} />
                    {
                        major.length > 0 &&
                        <div className="tw-mt-4 tw-space-y-2">
                            {
                                major.map(item => (
                                    <div key={`major-${item.key}`} className="tw-flex tw-items-center">
                                        {
                                            <input
                                                type="checkbox"
                                                name={item.key}
                                                checked={item.check}
                                                onChange={(e) => handleCheck(e, true)}
                                            />
                                        }
                                        <label className="tw-flex tw-items-center tw-ml-2">{jsonKeyToString(item.key)}
                                            <button className="tw-ml-2" onClick={() => deleteCustomItem(item.key, true)}><LuTrash2 size={15} /></button>
                                        </label>
                                    </div>

                                ))
                            }
                        </div>
                    }
                </div>


            </div>

            <div className="tw-w-full tw-flex tw-justify-between tw-items-center tw-mt-2">

                {
                    openModal &&
                    <ModalAddDefect
                        closeModal={() => setOpenModal(false)}
                        handleNewDefect={handleNewDefect}
                    />
                }


                <button className="tw-flex tw-items-center tw-gap-1" onClick={() => setOpenModal(true)}>
                    <AiFillPlusCircle size={22} className="tw-text-blue-600" />
                    <p className="tw-text-blue-600 tw-text-sm">New item</p>
                </button>



                <button
                    onClick={handleSend}
                    disabled={isLoading}
                    className="tw-bg-green-600 tw-text-white tw-rounded-full tw-py-2 tw-px-6 tw-mt-2 tw-flex tw-items-center tw-gap-2"
                >
                    Save
                    {isLoading && <SpinnerCustom color="white" />}
                </button>
            </div>
        </>
    )
}
